import { gettext } from '@eventbrite/i18n';
import {
    ABANDONED_ORDER_EMAILS,
    ALL_MAJOR_CREDIT_CARDS,
    ANALYTICS_BY_TICKET_TYPE,
    AT_THE_DOOR_SALES,
    ATTENDEE_CHECK_IN_VIA_APP,
    ATTENDEE_SHARING_TOOLS,
    AUTOMATED_SOCIAL_NOTIFICATIONS,
    BADGE_PRINTING_INTEGRATIONS,
    CROSS_EVENT_ANALYTICS,
    CUSTOM_URL,
    CUSTOMIZABLE_ATTENDEE_INFO,
    CUSTOMIZABLE_ORDER_CONFIRMATION,
    DETAILED_EXPORTS,
    DIGITAL_TICKETS,
    DIRECT_DEPOSIT_OR_CHECK,
    DISCOUNT_AND_ACCESS_CODES,
    DONATION_COLLECTION,
    FUNDRAISING_INTEGRATIONS,
    GOOGLE_ANALYTICS_INTEGRATION,
    GROUP_REGISTRATION,
    INDUSTRY_LEADING_SEARCH,
    MOBILE_OPTIMIZED_PURCHASE_FLOW,
    MOBILE_ORGANIZER_APP,
    MOBILE_TICKETS,
    ON_SITE_APP_INTEGRATIONS,
    OPEN_API,
    PASS_ON_FEES,
    PAYMENT_PROCESSING,
    PCI_COMPLIANT,
    PRICE_PER_FREE_TICKET,
    PRIVATE_EVENTS,
    PUBLIC_EVENTS,
    PUBLIC_LISTINGS,
    RECURRING_EVENTS,
    REGISTRATION_TRANSFERS,
    RESERVED_SEATING_LANDING_PAGE,
    SCHEDULED_PAYOUTS,
    SECURE_PAYMENT_PROCESSING,
    SELF_SERVICE_TRACKING_PIXELS,
    SELL_ON_YOUR_WEBSITE,
    SESSION_MANAGEMENT_INTEGRATIONS,
    STANDARD_CHECKOUT_FORM,
    SURVEY_INTEGRATIONS,
    TEAM_ACCESS_AND_PERMISSIONS,
    TICKET_SCANNING_VIA_APP,
    TICKET_TYPES,
    UNLIMITED_EVENTS,
    WAITLISTS,
} from '../../constants/featuresComparison';
import { STYLE_ANCHOR } from '@eventbrite/eds-button';

const getFeatures = (features) => {
    return features.map((feature) => {
        return { ...feature, perPlanData: feature.perPlanData.slice(0, 2) };
    });
};

export default {
    primaryHeading: gettext("Choose the solution that's right for you"),
    plans: [gettext('Flex or Pro'), gettext('Premium')],
    paymentProcessingFeature: PAYMENT_PROCESSING,
    sections: {
        0: {
            heading: gettext('Start Selling'),
            features: getFeatures([
                {
                    title: gettext(
                        'Customized onboarding and implementation services',
                    ),
                    perPlanData: [false, true],
                },
                {
                    title: gettext('1:1 consultations with event experts'),
                    perPlanData: [false, true],
                },
                {
                    title: gettext('Real-time access to support experts'),
                    perPlanData: [gettext('Variable'), true],
                },
                {
                    title: gettext(
                        'Collect additional revenue per ticket (royalties)',
                    ),
                    perPlanData: [false, true],
                },
                {
                    title: gettext('Ticket types (e.g. "Early Bird")'),
                    link: '/support/articleredirect?anum=3290',
                    perPlanData: [true, true],
                },
                PUBLIC_EVENTS,
                PRIVATE_EVENTS,
                UNLIMITED_EVENTS,
                STANDARD_CHECKOUT_FORM,
                DIGITAL_TICKETS,
                MOBILE_TICKETS,
                DONATION_COLLECTION,
                PASS_ON_FEES,
                FUNDRAISING_INTEGRATIONS,
                RECURRING_EVENTS,
                CUSTOM_URL,
                WAITLISTS,
                AT_THE_DOOR_SALES,
                {
                    title: gettext('Customizable attendee info collection'),
                    perPlanData: [true, true],
                },
                CUSTOMIZABLE_ORDER_CONFIRMATION,
                {
                    title: gettext('Reserved seating'),
                    link: '/l/reserved-seating/',
                    perPlanData: [true, true],
                },
                {
                    title: gettext('Registration transfers'),
                    perPlanData: [true, true],
                },
            ]),
        },
        1: {
            heading: gettext('Promote & Grow'),
            features: getFeatures([
                MOBILE_OPTIMIZED_PURCHASE_FLOW,
                PUBLIC_LISTINGS,
                INDUSTRY_LEADING_SEARCH,
                {
                    title: gettext('Email marketing'),
                    perPlanData: [true, true],
                },
                {
                    title: gettext('Paid social media ads*'),
                    perPlanData: [true, true],
                },
                {
                    title: gettext('Multi-event ads*'),
                    perPlanData: [true, true],
                },
                {
                    title: gettext('Eventbrite ads*'),
                    perPlanData: [true, true],
                },
                AUTOMATED_SOCIAL_NOTIFICATIONS,
                ATTENDEE_SHARING_TOOLS,
                ABANDONED_ORDER_EMAILS,
                {
                    title: gettext('Distribution to partner websites'),
                    perPlanData: [true, true],
                },
                {
                    title: gettext('Ticket sales on Facebook'),
                    perPlanData: [true, true],
                },
                DISCOUNT_AND_ACCESS_CODES,
                {
                    title: gettext('Sell on your website'),
                    perPlanData: [true, true],
                },
            ]),
        },
        2: {
            heading: gettext('Track & Optimize'),
            features: getFeatures([
                {
                    title: gettext('Sales summary dashboard'),
                    perPlanData: [true, true],
                },
                DETAILED_EXPORTS,
                MOBILE_ORGANIZER_APP,
                GOOGLE_ANALYTICS_INTEGRATION,
                SURVEY_INTEGRATIONS,
                SELF_SERVICE_TRACKING_PIXELS,
                CROSS_EVENT_ANALYTICS,
                {
                    title: gettext('Detailed analytics by ticket type'),
                    perPlanData: [true, true],
                },
            ]),
        },
        3: {
            heading: gettext('Streamline Operations'),
            features: getFeatures([
                TICKET_SCANNING_VIA_APP,
                ATTENDEE_CHECK_IN_VIA_APP,
                OPEN_API,
                BADGE_PRINTING_INTEGRATIONS,
                SESSION_MANAGEMENT_INTEGRATIONS,
                ON_SITE_APP_INTEGRATIONS,
                TEAM_ACCESS_AND_PERMISSIONS,
            ]),
        },
        4: {
            heading: gettext('Stay Secure'),
            features: getFeatures([
                ALL_MAJOR_CREDIT_CARDS,
                SECURE_PAYMENT_PROCESSING,
                PCI_COMPLIANT,
                DIRECT_DEPOSIT_OR_CHECK,
                {
                    title: gettext('Scheduled Payouts'),
                    perPlanData: [true, true],
                },
            ]),
        },
    },
    CTAs: [gettext('Get started for free'), gettext('Contact Sales')],
    CTAStyles: [STYLE_ANCHOR, STYLE_ANCHOR],
    pricePerFreeTicket: PRICE_PER_FREE_TICKET,
    showMaxFee: false,
};
